module.exports = __webpack_public_path__ + "img/key.7bc8d360.png";